<div class="material-page">
  
  <div *ngIf="pageReady">
    <h1 class="mat-headline-3" i18n>{{isCreatePage ? 'New listing' : 'Edit / Unlist'}}</h1>
    <mat-divider></mat-divider>
    
    <form #listingFormElement="ngForm" (ngSubmit)="isCreatePage ? createListing() : updateListing()" [formGroup]="listingForm">
      
      <div>
        <h2 class="mat-headline-5"><ng-container i18n>Title</ng-container> *</h2>
        <mat-form-field style="min-width: 343px; width: 100%; max-width: 500px;">
          <input matInput formControlName="title" required>
          <mat-hint align="end">{{listingForm.controls['title'].value?.length || 0}} / 50</mat-hint>
          <mat-error *ngIf="listingForm.controls['title'].errors?.['minlength']" i18n>Title should be at least 5 characters long</mat-error>
          <mat-error *ngIf="listingForm.controls['title'].errors?.['maxlength']" i18n>Title should be maximum 50 characters long</mat-error>
        </mat-form-field> 
      </div>
      
      <div>
        <h2 class="mat-headline-5" i18n>Description</h2>
        <mat-form-field style="min-width: 343px; width: 100%; max-width: 500px;">
          <textarea matInput formControlName="description" rows="10"></textarea>
          <mat-hint align="end">{{listingForm.controls['description'].value?.length || 0}} / 1000</mat-hint>
          <mat-error *ngIf="listingForm.controls['description'].errors?.['maxlength']" i18n>Description should be maximum 1000 characters long</mat-error>
        </mat-form-field>
      </div>
      
      <div>
        <h2 class="mat-headline-5"><ng-container i18n>Add / remove photos</ng-container> *</h2>
        <image-list-editor [pictures]="pictures" (onChange)="numberOfPicturesChanged()"></image-list-editor>
      </div>
      
      <div>
        <h2 class="mat-headline-5"><ng-container i18n>Condition</ng-container> *</h2>
        <mat-radio-group formControlName="condition" class="horizontal" required>
          <mat-radio-button value="1" i18n>New</mat-radio-button>
          <mat-radio-button value="2" i18n>Used - like new / Open box</mat-radio-button>
          <mat-radio-button value="3" i18n>Used - very good</mat-radio-button>
          <mat-radio-button value="4" i18n>Used - good</mat-radio-button>
          <mat-radio-button value="5" i18n>Used - fair</mat-radio-button>
          <mat-radio-button value="6" i18n>Used - poor / for parts or not working</mat-radio-button>
        </mat-radio-group>
      </div>
      
      <div>
        <h2 class="mat-headline-5"><ng-container i18n>Price</ng-container> *</h2>
        <mat-form-field style="width: 100%; max-width: 150px;">
          <input matInput formControlName="price" type="number" required>
          <span matTextSuffix>EUR</span>
        </mat-form-field>
      </div>

      <div *ngIf="isCreatePage">
        <h2 class="mat-headline-5"><ng-container i18n>Purchased in shop</ng-container> *</h2>
        <mat-form-field style="min-width: 343px; width: 100%; max-width: 500px;">
          <input matInput formControlName="purchasedInShop" required>
        </mat-form-field>
      </div>
      
      <div *ngIf="isCreatePage">
        <h2 class="mat-headline-5"><ng-container i18n>Purchase date</ng-container> *</h2>
        <mat-form-field>
          <input matInput [matDatepicker]="picker" formControlName="dateOfPurchase" i18n-placeholder placeholder="Choose a date">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
      
      <div *ngIf="isCreatePage">
        <h2 class="mat-headline-5"><ng-container i18n>Top level category</ng-container> *</h2>
        <mat-form-field style="min-width: 343px; width: 100%; max-width: 500px;">
          <mat-select formControlName="topLevelCategory">
            <mat-option *ngFor="let category of allTopLevelCategories" [value]="category">
              {{category}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      
      <div *ngIf="isCreatePage">
        <h2 class="mat-headline-5"><ng-container i18n>Categories</ng-container> *</h2>
        <mat-form-field style="min-width: 343px; width: 100%; max-width: 500px;">
          <mat-chip-grid #chipGrid formControlName="categories">
              <mat-chip-row *ngFor="let category of selectedCategories"
                            [editable]="true" 
                            (removed)="removeCategory(category)"
                            >
                {{category}}
                <button matChipRemove>
                  <mat-icon fontSet="material-symbols-outlined">cancel</mat-icon>
                </button>
              </mat-chip-row>
              <input placeholder="Add category..."
                     [matChipInputFor]="chipGrid"
                     [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                     (matChipInputTokenEnd)="addCategory($event)"
                     [matChipInputAddOnBlur]="true"
                     i18n-placeholder/>
            </mat-chip-grid>
            <mat-error *ngIf="listingForm.controls['categories'].errors?.['minlength']" i18n>Please enter at least 5 categories</mat-error>
        </mat-form-field>
      </div>

      
      <!--div>
        <h2>ADD / EDIT CATEGORIES *</h2>
        <mat-form-field style="width: 100%">
          <mat-chip-grid #chipGrid>
            <mat-chip-row *ngFor="let category of listingForm.controls['categories'].value" (removed)="remove(category)">
              <span style="text-transform: capitalize;">{{category}}</span>
              <button matChipRemove>
                <span class="material-symbols-outlined filled-icon">cancel</span>
              </button>
            </mat-chip-row>
          </mat-chip-grid>
          <input placeholder="Add category..." #categoryInput [formControl]="category"
            [matChipInputFor]="chipGrid" [matAutocomplete]="auto"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (matChipInputTokenEnd)="add($event)"/>
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
            <mat-option *ngFor="let category of filteredCategories | async" [value]="category">
              <span style="text-transform: capitalize;">{{category}}</span>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div-->
      
      <mat-divider></mat-divider>
      
      <div class="button-panel" *ngIf="isCreatePage">
        <button 
            mat-raised-button 
            type="submit"
            color="accent" 
            angulartics2On="click" 
            angularticsAction="CreateManualListingClick">
            
          <mat-icon fontSet="material-symbols-outlined">store</mat-icon>
          <ng-container i18n>LIST NOW</ng-container>
        </button>
      </div>
      
      <div class="button-panel" *ngIf="!isCreatePage">
        <button 
            mat-raised-button 
            type="submit"
            color="accent" 
            angulartics2On="click" 
            angularticsAction="UpdateListingClick"
            [angularticsCategory]="'' + analyticsCategory">
            
          <mat-icon fontSet="material-symbols-outlined">save</mat-icon>
          <ng-container i18n>SAVE CHANGES</ng-container>
        </button>
        <button 
            type="button" 
            mat-button 
            (click)="toPreview()"
            angulartics2On="click" 
            angularticsAction="DiscardChangesClick"
            [angularticsCategory]="'' + analyticsCategory">
            
          <mat-icon fontSet="material-symbols-outlined" type="button">delete</mat-icon>
          <ng-container i18n>DISCARD</ng-container>
        </button>
      </div>
    </form>
  </div>
</div>